export function applicantProfileUser (state) {
  return state.applicantProfileUser ?? null
}
